<template>
	<div>
		<select-user-defined-group v-model="userDefinedGroups" :displayAll="false" ref="userDefinedGroup" />
		<p>
			<em class="lt_text">Item {{ headers.class }} Selected by User Defined Group</em>
		</p>
		<div style="width: 100%; border: 1px solid #dbdbdb; padding: 5px; border-radius: 5px; min-height: 40px;">{{ itemClassesByUserDefinedGroupStr }}</div>
	</div>
</template>

<script>
import SelectUserDefinedGroup from '@/components/common/SelectUserDefinedGroup';
import { apiSelectClassesByUserDefinedGroups } from '@/api/item/userDefined';
export default {
	data: () => ({
		userDefinedGroups: '', // 선택된 UserDefinedGroup을 '|'를 구분자로 하여 합친 문자열
		itemClassesByUserDefinedGroup: [],
	}),
	components: {
		SelectUserDefinedGroup,
	},
	computed: {
		userDefinedGroupArr: {
			get() {
				let arr = this.userDefinedGroups && this.userDefinedGroups.trim() ? this.userDefinedGroups.split('|') : [];
				for (let i = 0; i < arr.length; i++) {
					if (!this.$refs.userDefinedGroup.isContain(arr[i].trim())) {
						arr.splice(i, 1);
						i--;
					}
				}

				return arr;
			},
		},
		itemClassesByUserDefinedGroupStr: {
			get() {
				return this.itemClassesByUserDefinedGroup.join(', ');
			},
		},

		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	watch: {
		userDefinedGroupArr: {
			async handler(newValue, oldValue) {
				let isChange = false;
				newValue.forEach(n => {
					if (!oldValue.some(o => o === n)) isChange = true;
				});

				if (!isChange) {
					oldValue.forEach(o => {
						if (!newValue.some(n => n === o)) isChange = true;
					});
				}

				if (!isChange) return;

				let udNos = [];
				newValue.forEach(n => {
					let udNo = this.$refs.userDefinedGroup.getUdNo(n);
					if (udNo) udNos.push(udNo);
				});

				this.itemClassesByUserDefinedGroup = [];
				if (udNos.length > 0) {
					let { data } = await apiSelectClassesByUserDefinedGroups(udNos);
					data.forEach(c => this.itemClassesByUserDefinedGroup.push(c.classCode));
				}

				this.$emit('change', this.itemClassesByUserDefinedGroup);
			},
		},
	},
	methods: {
		reset() {
			this.userDefinedGroups = '';
			this.itemClassesByUserDefinedGroup = [];
			this.$refs.userDefinedGroup.reset();
		},
	},
};
</script>

<style></style>
